<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import {useSecurityStore} from "@/stores/Security";
import {usePaySectionStore} from "@/stores/PaySection";
import {onMounted, ref} from "vue";
import axios from "axios";
import PaySectionTable from "@/views/PaySection/Components/PaySectionTable.vue";

export default {
    components: {PaySectionTable},
    setup() {
        const {$i18n, $router} = useTools();
        const {
            inputColor,
            backgroundColor,
            loading,
            paginationListLength,
            itemsPerPage,
            page,
            pageCount
        } = useSharedData();
        const {itemClick, rowColor} = useSharedMethod();
        const securityStore = useSecurityStore();
        const paySectionStore = usePaySectionStore();


        const search = ref(null);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                width: "300px",
                value: "label",
            },
            {
                text: $i18n.t("pay_section.type"),
                align: "start",
                sortable: true,
                value: "type",
            },
            {
                text: $i18n.t("pay_section.cotisable"),
                align: "start",
                sortable: true,
                value: "cotisable",
            },
            {
                text: $i18n.t("pay_section.imposable"),
                align: "start",
                sortable: true,
                width: "150",
                value: "imposable",
            },
            {
                text: $i18n.t("common.formula"),
                align: "start",
                sortable: false,
                value: "formule",
            },
            {
                text: $i18n.t("common.brute"),
                align: "start",
                sortable: true,
                value: "brute",
            },
            {
                text: $i18n.t("pay_section.holiday"),
                align: "start",
                sortable: true,
                value: "conge",
            },
            {
                text: $i18n.t("pay_section.printed"),
                align: "start",
                sortable: true,
                width: "150px",
                value: "bulteinePrintable",
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/paySections').then((response) => {
                paySectionStore.setPaySections(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(event, {item}) {
            $router.push({name: "pay_sections.view", params: {id: item.id}});
        }

        function add() {
            paySectionStore.setPaySection({...paySectionStore.backupPaySection});
            $router.push({name: 'pay_sections.add'});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            paySectionStore,
            loading,
            inputColor,
            backgroundColor,
            paginationListLength,
            itemsPerPage,
            page,
            pageCount,
            headers,
            search,
            itemClick,
            rowColor,
            view,
            findAll,
            add
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.pay_sections')"
            :total="paySectionStore.paySections.length"
        >
            <template #rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="add"
                />
            </template>
            <template #content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"/>
                        </v-col>
                    </v-row>
                </v-container>
                <pay-section-table
                    :pay-sections="paySectionStore.paySections"
                    :loading="loading"
                    :search="search"
                    :show-update-action="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    :show-delete-action="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    parent-link="pay_sections"
                />
            </template>
        </w-app>
        <router-view/>
    </div>
</template>

<style>

</style>